import { default as parentScope } from '../types';
const SCOPE = `${parentScope}.precisionPolicy`;
export default SCOPE;

export const INIT = `${SCOPE}/INIT`;
export const SET_DATA = `${SCOPE}/SET_DATA`;
export const DELETE_POLICY = `${SCOPE}/DELETE_POLICY`;
export const CLONE_POLICY = `${SCOPE}/CLONE_POLICY`;
export const UPDATE_POLICY = `${SCOPE}/UPDATE_POLICY`;
export const ACTIVATE_POLICY = `${SCOPE}/ACTIVATE_POLICY`;
export const REORDER_POLICIES = `${SCOPE}/REORDER_POLICIES`;
export const TOGGLE_LOADING = `${SCOPE}/TOGGLE_LOADING`;
export const TOGGLE_MODAL = `${SCOPE}/TOGGLE_MODAL`;
export const TOGGLE_SUBMITTING = `${SCOPE}/TOGGLE_SUBMITTING`;
export const TOGGLE_SORTABLE = `${SCOPE}/TOGGLE_SORTABLE`;
export const SET_VIEW = `${SCOPE}/SET_VIEW`;
export const TOGGLE_EXAPANDED_VIEW = `${SCOPE}/TOGGLE_EXAPANDED_VIEW`;
